<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 5">
      <circle
        id="Ellipse 2"
        cx="12"
        cy="12"
        r="11.5"
        fill="#110F13"
        stroke="#FDFDFD"
      />
      <g id="Group 3">
        <path
          id="Vector 5"
          d="M12 16V8"
          stroke="#FDFDFD"
          stroke-width="1.6"
          stroke-linecap="round"
        />
        <path
          id="Vector 6"
          d="M16 12L8 12"
          stroke="#FDFDFD"
          stroke-width="1.6"
          stroke-linecap="round"
        />
      </g>
    </g>
  </svg>
</template>
